import { useEffect, useState, useContext } from "react";
import { AppContext } from "../App";
import { getInlineLoader } from "../Helpers";
import OneEvent from "./OneEvent";

export default function EventBanner(props) {
  const appContext = useContext(AppContext);

  const [ready, setReady] = useState(false);

  async function init() {
    setReady(false);
    await Promise.all([appContext.getAllEvents()]);
    setReady(true);
  }

  useEffect(() => {
    init();
  }, []);

  if (ready) {
    return (
      <div
        className="MainBodySection bg-background"
        style={{
          paddingTop: "50px",
          paddingBottom: "50px",
        }}
      >
        <div className="container">
          <div className="row">
            {props.showHeader !== false ? (
              <div className="col-md-12 text-center">
                <h4 className="main-section-title">
                  Events & Trainings
                  <span
                    style={{
                      display: "block",
                      borderBottom: "3px solid var(--secondaryColor)",
                      width: "50px",
                      margin: "10px auto 0",
                    }}
                  ></span>
                </h4>
              </div>
            ) : null}

            {appContext.allEvents && appContext.allEvents.length > 0 ? (
              appContext.allEvents.map((item, i) => {
                return (
                  <div key={i} className="col-md-6" data-aos="fade-up" data-aos-delay={i * 80}>
                    <OneEvent data={item} />
                  </div>
                );
              })
            ) : (
              <div className="col-md-12 mb-1 mt-1">
                <h6>No data was found</h6>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }

  return <div className="container mSupportLoading">{getInlineLoader()}</div>;
}
